import script from "./FormUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./FormUpload.vue?vue&type=script&setup=true&lang=js"

import "./FormUpload.vue?vue&type=style&index=0&id=aa87d1ca&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa87d1ca"]])

export default __exports__